module.exports = __webpack_public_path__ + "f1e11a7437106cb0dde99ecf7bf2d17b.jpg";